import { createFileRoute } from '@tanstack/react-router'

import { requireShopEnabled } from '@/lib/shop-module'
import { queryClient } from '@/router'

// Mọi màn /retail/* thuộc module bán lẻ: SHOP_ENABLED tắt → trang không tồn tại.
export const Route = createFileRoute('/_app/_authed/_sidebar/retail')({
    beforeLoad: () => requireShopEnabled(queryClient),
})
